/**
 * a function that takes a pathname from the router history and returns a page title
 * A few notes on the regex:
 *  ^ denotes the start of a string
 *  \/ is an escaped forward slash (/)
 *  \w+ means one or more letters or numbers
 *  [\w-]+ means one or more instances of any letter, number, or -
 *  \d+ means one or more numbers
 *  .+ means one or more of any character
 *  [\/]* means 0 or more forward slashes (/)
 *  $ denotes the end of the string
 *  i means case-insensitive
 * @param pathname
 */
export const datadogViewNames = (pathname: string): string => {
  switch (true) {
    case /^\/$/i.test(pathname):
    case /^\/app\/v2\.0[\/]*$/i.test(pathname):
      return "Project Dashboard";
    case /\/projects\/[\d?]+[\/]*$/i.test(pathname):
      return "Project Overview";

    case /\/projects\/[\d?]+\/accuracy[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy";
    case /\/projects\/[\d?]+\/accuracy\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with County";
    case /\/projects\/[\d?]+\/accuracy\/county\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with County and Specialty";
    case /\/projects\/[\d?]+\/accuracy\/county\/[\w?]+\/specialty\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with County, Specialty, and Inspection";
    case /\/projects\/[\d?]+\/accuracy\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with Inspection";
    case /\/projects\/[\d?]+\/accuracy\/specialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with Specialty";
    case /\/projects\/[\d?]+\/accuracy\/specialty\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with County and Specialty";
    case /\/projects\/[\d?]+\/accuracy\/specialty\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with Specialty and Inspection";
    case /\/projects\/[\d?]+\/accuracy\/specialty\/[\w?]+\/state\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State and Specialty"
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/county\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/accuracy\/specialty\/[\w?]+\/state\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/specialty\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State, County, and Specialty";
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+\/specialty\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State, Specialty, and Inspection";
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State";
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State and County";
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/county\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State, County, and Inspection";
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/county\/[\w?]+\/specialty\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State, County, Specialty, and Inspection";
    case /\/projects\/[\d?]+\/accuracy\/state\/[\w?]+\/inspection\/[\w-]+[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy with State and Inspection";

    case /\/projects\/[\d?]+\/accuracy\/export\/[\w?]+\/false[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/accuracy\/export\/[\w?]+\/true[\/]*$/i.test(pathname):
      return "Project Overview - Accuracy Export";

    case /\/projects\/[\d?]+\/adequacy[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy";
    case /\/projects\/[\d?]+\/adequacy\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with County";
    case /\/projects\/[\d?]+\/adequacy\/county\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/adequacy\/specialty\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with County and Specialty";
    case /\/projects\/[\d?]+\/adequacy\/specialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with Specialty";
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with State";
    case /\/projects\/[\d?]+\/adequacy\/specialty\/[\w?]+\/state\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with State and Specialty";
    case /\/projects\/[\d?]+\/adequacy\/specialty\/[\w?]+\/state\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+\/county\/[\w?]+\/specialty\/[\w?]+[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+\/specialty\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with State, County, and Specialty";
    case /\/projects\/[\d?]+\/adequacy\/state\/[\w?]+\/county\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy with State and County";

    case /\/projects\/[\d?]+\/adequacy\/export\/[\w?]+\/false[\/]*$/i.test(pathname):
    case /\/projects\/[\d?]+\/adequacy\/export\/[\w?]+\/true[\/]*$/i.test(pathname):
      return "Project Overview - Adequacy Export";

    case /\/access-reports[\/]*$/i.test(pathname):
      return "Access Reports";
    case /\/access-reports\/[\w?]+[\/]*$/i.test(pathname):
      return "Access Reports Home";
    case /\/access-reports\/admin\/add-product\/[\w?]+[\/]*$/i.test(pathname):
      return "Access Reports - Add Product";
    case /\/access-reports\/admin\/dashboard[\/]*$/i.test(pathname):
      return "Access Reports - Admin Dashboard";
    case /\/access-reports\/wizard\/[\w?]+[\/]*$/i.test(pathname):
      return "Access Reports - Wizard";

    case /\/account\/manage\/profile[\/]*$/i.test(pathname):
      return "Manage User Profile";

    case /\/admin\/client-administration[\/]*$/i.test(pathname):
      return "Admin Dashboard - Client Administration";
    case /\/admin\/client-administration\/[\d?]+[\/]*$/i.test(pathname):
      return "Admin Dashboard - Client Administration - Detail";
    case /\/admin\/client-administration\/create[\/]*$/i.test(pathname):
      return "Admin Dashboard - Client Administration - Create";

    case /\/admin\/dashboard[\/]*$/i.test(pathname):
      return "Admin Dashboard";
    case /\/admin\/user-administration[\/]*$/i.test(pathname):
      return "Admin Dashboard - User Administration";
    case /\/admin\/user-administration\/[\d?]+[\/]*$/i.test(pathname):
      return "Admin Dashboard - User Administration - Detail";
    case /\/admin\/user-administration\/create[\/]*$/i.test(pathname):
      return "Admin Dashboard - User Administration - Create";
    case /\/admin\/user-sessions[\/]*$/i.test(pathname):
      return "Admin Dashboard - Admin Dashboard - User Sessions";
    case /\/admin\/login-statistics[\/]*/i.test(pathname):
      return "Admin Dashboard - Admin - Login Statistics";
    case /\/admin\/manage-tutorials[\/]*/i.test(pathname):
      return "Admin Dashboard - Admin - Manage Tutorials";
    case /\/admin\/provider-results[\/]*/i.test(pathname):
      return "Admin Dashboard - Provider Results";

    case /\/member-populations[\/]*$/i.test(pathname):
      return "Member Populations Dashboard";
    case /\/member-populations\/[\w?]+\/detail[\/]*$/i.test(pathname):
      return "Member Population Detail";
    case /\/member-populations\/create-filtered[\/]*$/i.test(pathname):
      return "Member Population - Create Filtered";


    case /\/projects\/[\d?]+\/clone[\/]*$/i.test(pathname):
      return "Clone Project";
    case /\/projects\/[\d?]+\/edit\/service-area[\/]*$/i.test(pathname):
      return "Edit Project Service Area";

    case /\/projects\/[\d?]+\/summary[\/]*$/i.test(pathname):
      return "Project Summaries";

    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byAddressCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Address Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byAddressCount\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Network Providers By Address Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byCounty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By County";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byCounty\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By County - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byGeocode\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Geocode";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byGeocode\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Geocode - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byNPIStatus\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By NPI Status";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byNPIStatus\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By NPI Status - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/bySpecialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Specialty";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/bySpecialty\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Network Providers By Specialty - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/bySpecialtyCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Specialty Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/bySpecialtyCount\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By Specialty Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byState\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By State";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/network\/byState\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Network Providers By State - Export";

    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byAddressCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Address Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byAddressCount\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Prospect Providers By Address Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byCounty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By County";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byCounty\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By County - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byGeocode\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Geocode";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byGeocode\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Geocode - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byNPIStatus\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By NPI Status";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byNPIStatus\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By NPI Status - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/bySpecialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Specialty";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/bySpecialty\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Prospect Providers By Specialty - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/bySpecialtyCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Specialty Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/bySpecialtyCount\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By Specialty Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byState\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By State";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/network\/prospect\/byState\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Prospect Providers By State - Export";

    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byAddressCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Address Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byAddressCount\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Address Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byCounty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By County";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byCounty\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By County - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byGeocode\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Geocode";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byGeocode\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Geocode - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byNPIStatus\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By NPI Status";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byNPIStatus\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By NPI Status - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/bySpecialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Specialty";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/bySpecialty\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Specialty - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/bySpecialtyCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Specialty Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/bySpecialtyCount\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By Specialty Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byState\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By State";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/network\/byState\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Network Providers By State - Export";

    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byAddressCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Address Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byAddressCount\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Address Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byCounty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By County";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byCounty\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By County - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byGeocode\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Geocode";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byGeocode\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Geocode - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byNPIStatus\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By NPI Status";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byNPIStatus\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By NPI Status - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/bySpecialty\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Specialty";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/bySpecialty\/[\w?]+\/export[\/]*/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Specialty - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/bySpecialtyCount\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Specialty Count";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/bySpecialtyCount\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By Specialty Count - Export";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byState\/[\w?]+[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By State";
    case /\/projects\/[\d?]+\/summary\/[\w?]+\/servicing\/prospect\/byState\/[\w?]+\/export[\/]*$/i.test(pathname):
      return "Project Summaries - Servicing Prospect Providers By State - Export";

    case /\/projects\/[\d?]+\/summary\/Address[\/]*$/i.test(pathname):
      return "Project Summaries - By Address";
    case /\/projects\/[\d?]+\/summary\/ByCounty[\/]*$/i.test(pathname):
      return "Project Summaries - By County";
    case /\/projects\/[\d?]+\/summary\/ByGeocode[\/]*$/i.test(pathname):
      return "Project Summaries - By Geocode";
    case /\/projects\/[\d?]+\/summary\/BySpecialty[\/]*$/i.test(pathname):
      return "Project Summaries - By Specialty";
    case /\/projects\/[\d?]+\/summary\/ByState[\/]*$/i.test(pathname):
      return "Project Summaries - By State";
    case /\/projects\/[\d?]+\/summary\/NPI[\/]*$/i.test(pathname):
      return "Project Summaries - By NPI";
    case /\/projects\/[\d?]+\/summary\/Overall[\/]*$/i.test(pathname):
      return "Project Summaries - By Overall";
    case /\/projects\/[\d?]+\/summary\/Specialty[\/]*$/i.test(pathname):
      return "Project Summaries - By Specialty";

    case /\/projects\/create\/[\w?]+[\/]*$/i.test(pathname):
      return "Create Project Wizard";
    case /\/projects\/create\/review[\/]*$/i.test(pathname):
      return "Create Project Review";

    case /\/projects\/share[\/]*$/i.test(pathname):
      return "Bulk Share Projects";

    case /\/reports[\/]*$/i.test(pathname):
    case /\/my-downloads[\/]*/i.test(pathname):
      return "Reports";

    case /\/tools\/accuracyevidence[\/]*$/i.test(pathname):
      return "Accuracy Evidence";
    case /\/tools\/lookupaddress[\/]*$/i.test(pathname):
      return "Look Up Address";
    case /\/tools\/lookupcounty\/.+\/[\w?]+[\/]*$/i.test(pathname):
      return "Look Up County";
    case /\/tools\/lookupstate[\/]*$/i.test(pathname):
      return "Look Up State";
    case /\/tools\/lookupzip\/[\w?]+[\/]*$/i.test(pathname):
      return "Look Up Zip";

    case /\/tutorials[\/]*$/i.test(pathname):
      return "Tutorials";

    case /\/home\/notfound[\/]*/i.test(pathname):
      return "Not Found";
    case /\/projects\/[\d?]+\/composite[\/]*/i.test(pathname):
      return "Project Overview - Composite";

    case /\/templates\/adequacy\/.+\/[\w?]+[\/]*/i.test(pathname):
      return "Templates - Adequacy";
    case /\/templates\/accuracy\/.+\/[\w?]+[\/]*/i.test(pathname):
      return "Templates - Accuracy";
    case /\/terminations\/import[\/]*/i.test(pathname):
      return "Terminations - Import"
    case /\/terminations\/view[\/]*/i.test(pathname):
      return "Terminations - View";

    default:
      return pathname;
  }
}
